"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeSearchConfigs = normalizeSearchConfigs;
exports.stringsToNumbers = stringsToNumbers;
var _toPath2 = _interopRequireDefault(require("lodash/toPath"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function normalizeSearchConfigs(configs) {
  if (!Array.isArray(configs)) {
    throw new Error('The search config of a document type must be an array of search config objects');
  }
  return configs.map(function (conf) {
    if (conf === 'defaults') {
      return conf;
    }
    if (!(0, _isPlainObject2.default)(conf)) {
      throw new Error('Search config must be an object of {path: string, weight: number}');
    }
    return {
      weight: 'weight' in conf ? conf.weight : 1,
      path: (0, _toPath2.default)(conf.path).map(stringsToNumbers),
      mapWith: typeof conf.mapWith === 'string' ? conf.mapWith : undefined
    };
  });
}
function stringsToNumbers(pathSegment) {
  var pathAsNumber = Number(pathSegment);
  if (!Number.isNaN(pathAsNumber)) {
    return pathAsNumber;
  }
  return pathSegment;
}